import React, { useEffect } from 'react';
import { FileText } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-12 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center">
              <FileText className="w-7 h-7 text-amber-600" />
            </div>
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-slate-800">Termini e Condizioni</h1>
              <p className="text-slate-500">G&B Wood</p>
            </div>
          </div>
          <p className="text-lg text-slate-700 font-medium">
            Termini e Condizioni di Utilizzo del Sito
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            
            {/* 1. Oggetto */}
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">1. Oggetto</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                I presenti Termini e Condizioni disciplinano l'uso del sito web di G&B Wood da parte degli utenti.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Accedendo al sito, l'utente accetta integralmente i presenti Termini.
              </p>
            </section>

            {/* 2. Natura dei servizi */}
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">2. Natura dei servizi</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Il sito ha lo scopo di:
              </p>
              <ul className="list-disc list-inside text-slate-600 mb-4 space-y-1">
                <li>presentare i servizi di posa parquet e lavorazioni in legno</li>
                <li>consentire agli utenti di richiedere informazioni o preventivi</li>
              </ul>
              <p className="text-slate-600 leading-relaxed">
                Il sito non effettua vendite online di prodotti o servizi: la conclusione di qualsiasi contratto avviene offline, dopo contatto diretto.
              </p>
            </section>

            {/* 3. Utilizzo corretto del sito */}
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">3. Utilizzo corretto del sito</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                L'utente si impegna a:
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-1">
                <li>utilizzare il sito nel rispetto della legge e dei presenti Termini</li>
                <li>non fornire dati falsi, incompleti o di terzi senza consenso</li>
                <li>non tentare di violare la sicurezza del sito o dei sistemi collegati</li>
              </ul>
            </section>

            {/* 4. Proprietà intellettuale */}
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">4. Proprietà intellettuale</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Tutti i contenuti del sito (testi, foto, logo, grafica, layout) sono di proprietà di G&B Wood o utilizzati con licenza.
              </p>
              <p className="text-slate-600 leading-relaxed">
                È vietata qualsiasi riproduzione, copia o utilizzo non autorizzato.
              </p>
            </section>

            {/* 5. Limitazione di responsabilità */}
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">5. Limitazione di responsabilità</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                G&B Wood si impegna a mantenere il sito aggiornato e funzionante, ma:
              </p>
              <ul className="list-disc list-inside text-slate-600 mb-4 space-y-1">
                <li>non garantisce l'assenza di errori o interruzioni del servizio</li>
                <li>non risponde per danni derivanti dall'utilizzo del sito o da informazioni in esso contenute</li>
                <li>non è responsabile di eventuali contenuti di siti esterni collegati tramite link</li>
              </ul>
              <p className="text-slate-600 leading-relaxed">
                Le informazioni pubblicate hanno scopo informativo e non costituiscono offerta al pubblico vincolante.
              </p>
            </section>

            {/* 6. Link a siti di terzi */}
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">6. Link a siti di terzi</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Il sito può contenere collegamenti a siti di terzi.
              </p>
              <p className="text-slate-600 leading-relaxed">
                G&B Wood non controlla tali siti e non è responsabile di contenuti, servizi o trattamenti dati effettuati da tali soggetti.
              </p>
            </section>

            {/* 7. Modifiche al sito e alle condizioni */}
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">7. Modifiche al sito e alle condizioni</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                G&B Wood si riserva il diritto di modificare, sospendere o interrompere il sito o parti di esso, nonché di aggiornare i presenti Termini in qualsiasi momento.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Le modifiche sono efficaci dalla loro pubblicazione.
              </p>
            </section>

            {/* 8. Legge applicabile e foro competente */}
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-slate-800 mb-4">8. Legge applicabile e foro competente</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                I presenti Termini sono disciplinati dalla legge italiana.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Per qualsiasi controversia sarà competente in via esclusiva il Foro di Trapani, salvo diverse previsioni inderogabili di legge.
              </p>
            </section>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPage;
